<script>
  import { Block } from '@reuters-graphics/graphics-components';
  import { assets } from '$app/paths';
  let { block } = $props();
</script>

<Block width="normal">
  <div class="row">
    {#each block.items as item}
      <div class="col">
        <div class="desc">
          <div class="h4 !fmt-0">{item.title}</div>
          <p class="font-sans leading-tight">{item.text}</p>
        </div>
        <img src="{assets}/{item.img}" alt={item.altText} />
      </div>
    {/each}
  </div>
</Block>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  .row {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .col {
    width: 100%;
    display: flex;
    align-items: center;
  }

  img {
    width: 300px;
    margin-block: 0;
  }

  p {
    font-size: calc(0.9 * var(--theme-font-size-base));
  }

  @media (max-width: mixins.$column-width-normal) {
    .col {
      flex-direction: column-reverse;
    }
  }
</style>
